import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/effect-creative';
import {Navigation,} from 'swiper/modules';

export default {
  init() {
    console.log('ricetta');

    
	
	const swiperRicette = new Swiper('.swiperRicette', {
		modules: [Navigation],
		slideToClickedSlide: false,
		lazy: {
			loadPrevNext: true, // pre-loads the next image to avoid showing a loading placeholder if possible
			loadPrevNextAmount: 2 // preload the next 2 images
		},			
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		slidesPerView: 1,
		spaceBetween: 10,
		direction: 'horizontal',
		loop: false,
		on: {
			resize: function enableOnlyMobile(swiperRicette){
				// Disable the slider when the window width is less than or equal to 960
				if(window.innerWidth > 768){
					swiperRicette.disable()
					swiperRicette.el.classList.add('-non-slider')
				}else{
					swiperRicette.enable()
					swiperRicette.el.classList.remove('-non-slider')
				}
			},
		}
	});

	const swiperPizze = new Swiper('.swiperPizze', {
		modules: [Navigation],
		slideToClickedSlide: false,
		lazy: {
			loadPrevNext: true, // pre-loads the next image to avoid showing a loading placeholder if possible
			loadPrevNextAmount: 2 // preload the next 2 images
		},			
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		slidesPerView: 1,
		spaceBetween: 10,
		direction: 'horizontal',
		loop: false,
		on: {
			resize: function enableOnlyMobile(swiperPizze){
				// Disable the slider when the window width is less than or equal to 960
				if(window.innerWidth > 768){
					swiperPizze.disable()
					swiperPizze.el.classList.add('-non-slider')
				}else{
					swiperPizze.enable()
					swiperPizze.el.classList.remove('-non-slider')
				}
			},
		}
	});

	const swiperGuide = new Swiper('.swiperGuide', {
		modules: [Navigation],
		slideToClickedSlide: false,
		lazy: {
			loadPrevNext: true, // pre-loads the next image to avoid showing a loading placeholder if possible
			loadPrevNextAmount: 2 // preload the next 2 images
		},			
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		slidesPerView: 1,
		spaceBetween: 10,
		direction: 'horizontal',
		loop: false,
		on: {
			resize: function enableOnlyMobile(swiperGuide){
				// Disable the slider when the window width is less than or equal to 960
				if(window.innerWidth > 768){
					swiperGuide.disable()
					swiperGuide.el.classList.add('-non-slider')
				}else{
					swiperGuide.enable()
					swiperGuide.el.classList.remove('-non-slider')
				}
			},
		}
	});


	const showMoreRicette = document.querySelector('#ricetteShowMore');
	const showMorePizze = document.querySelector('#pizzeShowMore');
	const showMoreGuide = document.querySelector('#guideShowMore');
	
	let ricetteBox = document.querySelectorAll('.ricetta');
	let pizzeBox = document.querySelectorAll('.pizze');
	let guideBox = document.querySelectorAll('.guide');
	let counterRicette = 5;
	let counterPizze = 5;
	let counterGuide = 5;
	let ricetteBool = false;
	let pizzeBool = false;
	let guideBool = false;

	//only the first 6 elements are visible
	if(window.innerWidth > 768){
		ricetteBox.forEach((el, i) => {
			if (i > counterRicette) {
				el.classList.add('hidden');
			}
		});

		pizzeBox.forEach((el, i) => {
			if (i > counterPizze) {
				el.classList.add('hidden');
			}
		});

		guideBox.forEach((el, i) => {
			if (i > counterGuide) {
				el.classList.add('hidden');
			}
		});
	}

	//show more button
	showMoreRicette.addEventListener('click', (e) => {
		counterRicette += 6;
		counterRicette >= ricetteBox.length-1 ? showMoreRicette.classList.add('md:!hidden') : null;
		ricetteBox.forEach((el, i) => {
			if (i <= counterRicette) {
				el.classList.remove('hidden');
			}
		});
	});

	//show more button
	showMorePizze.addEventListener('click', (e) => {
		counterPizze += 6;
		console.log(counterPizze);
		console.log(pizzeBox.length);
		counterPizze >= pizzeBox.length-1 ? showMorePizze.classList.add('md:!hidden') : null;
		pizzeBox.forEach((el, i) => {
			if (i <= counterPizze) {
				el.classList.remove('hidden');
			}
		});
	});

	showMoreGuide.addEventListener('click', (e) => {
		counterGuide += 6;
		counterGuide >= guideBox.length-1 ? showMoreGuide.classList.add('md:!hidden') : null;
		guideBox.forEach((el, i) => {
			if (i <= counterGuide) {
				el.classList.remove('hidden');
			}
		});
	});

	window.addEventListener('resize', () => {
		windowResizeRicette();
		windowResizePizze();
	})

	function windowResizeRicette(){
		if(window.innerWidth < 768){
			if(!ricetteBool){
				ricetteBox.forEach((el) => {
					el.classList.remove('hidden');
				});
				ricetteBool = true;
			}
			
		}
		else {
			if(ricetteBool){
				ricetteBox.forEach((el, i) => {
					if (i > counterRicette) {
						el.classList.add('hidden');
					}
				});
				ricetteBool = false;
			}

		}	
	}

	function windowResizePizze(){
		if(window.innerWidth < 768){
			if(!pizzeBool){
				pizzeBox.forEach((el) => {
					el.classList.remove('hidden');
				});
				pizzeBool = true;
			}
			
		}
		else {
			if(pizzeBool){
				pizzeBox.forEach((el, i) => {
					if (i > counterPizze) {
						el.classList.add('hidden');
					}
				});
				pizzeBool = false;
			}

		}	
	}

	function windowResizeGuide(){
		if(window.innerWidth < 768){
			if(!guideBool){
				guideBox.forEach((el) => {
					el.classList.remove('hidden');
				});
				guideBool = true;
			}
			
		}
		else {
			if(guideBool){
				guideBox.forEach((el, i) => {
					if (i > counterGuide) {
						el.classList.add('hidden');
					}
				});
				guideBool = false;
			}

		}	
	}
	
	windowResizeRicette();
	windowResizePizze();
	windowResizeGuide();


	new Swiper('.swiperFavolaProdotti', {
		modules: [Navigation],
		slideToClickedSlide: true,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		slidesPerView: 3,
		breakpoints: {
			1024: {
				slidesPerView: 3,
			},
			768: {
				slidesPerView: 1,
			},
			320: {
				slidesPerView: 1,
			},
		},
		spaceBetween: 50,
		direction: 'horizontal',
		loop: false,
	});
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};